import { listCitiesbyState } from '@/store/getters';
import { baseStore } from './base-store/base-store';
import router from '@/router';
import axios from 'axios';
import { userType } from '@/plugins/enums';
import api from '@/plugins/api';

export function checkError(statusError) {
  if (statusError === 405) {
    console.log('Rota inválida');
  } else if (statusError === 400) {
    console.log('Bad Request');
  } else if (statusError === 401) {
    handle401Error();
  } else if (statusError === 404) {
    console.log('Registro não encontrado');
  } else if (statusError === 403) {
    console.log('Sem permissão');
  } else if (statusError === 500) {
    console.log('Erro no servidor');
  }
}

export function formattedDate(value) {
  if (value.length === 10) {
    let date = value.split('-');

    if ((date.length === 3) && !isNaN(date[0]) && !isNaN(date[1]) && !isNaN(date[2])) {
      return date[2] + '/' + date[1] + '/' + date[0];
    }
  } else if ((value.length === 25) && (value.substr(10, 1) === 'T') &&
    ([ '-', '+' ].indexOf(value.substr(19, 1)) > -1)) {
    let temp = value.split('T');
    let date = temp[0].split('-');
    let time = temp[1].split(':');

    return date[2] + '/' + date[1] + '/' + date[0] + ' ' + time[0] + ':' + time[1];
  } else {
    try {
      let date = new Date(value.replace(/-/g, '/'));

      if (!isNaN(date)) {
        return date.toLocaleString('pt-BR', baseStore.state.dateDefaultOptions);
      }
    } catch (e) {
    }
  }

  return value;
}

export function addOneMinute(date) {
  let splittedDate = date.split(' ');
  let futureDate = new Date(new Date(splittedDate[0].replace(/-/g, '/') + ' ' + splittedDate[1].substr(0, 5)).getTime() + 60000);
  return futureDate.toLocaleString('pt-BR', baseStore.state.dateDefaultOptions);
}

export function removeOneSecond(date) {
  let formattedDate = date.split(' ');
  let futureDate = new Date(new Date(formattedDate[0].replace(/-/g, '/') + ' ' + formattedDate[1]).getTime() - 600);
  let splittedPastDate = futureDate.toLocaleString('pt-BR').split(' ');
  let pastDay = formatDate(splittedPastDate[0]).replace(/-/g, '/');
  return formattedDate(pastDay + ' ' + splittedPastDate[1]);
}

export function dateWithMonthWritten(date) {
  date = formattedDate(date);
  date = date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2];
  let dateMonth = new Date(date).toLocaleString('pt-BR', { month: 'long' });
  dateMonth = dateMonth.charAt(0).toUpperCase() + dateMonth.slice(1);
  return dateMonth + ' de ' + date.split('/')[2];
}

export function formatDateAndHour(dateAndHour) {
  let date = dateAndHour.split(' ')[0];
  let hour = dateAndHour.split(' ')[1];
  if (hour && hour.split(':').length < 2) {
    return `${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]} ${hour}:00`;
  } else if (hour) {
    return `${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]} ${hour}`;
  } else {
    return `${date.split('/')[2]}-${date.split('/')[1]}-${date.split('/')[0]} 00:00:00`;
  }
}

export function formatDate(date) {
  if (date.trim().length <= 10) {
    return date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0];
  }
}

export function formatDateCorrectPattern(date) {
  return date.replace(/-/g, '/');
}

export function newDateWithoutHour(onlyDate) {
  return new Date(onlyDate + ' 00:00');
}

export function addDays(date, numberOfDays) {
  let result = new Date(date);
  result.setDate(result.getDate() + numberOfDays);
  return result;
}

export function calculateDaysAgo(date, numberOfDays) {
  let result = new Date(date);
  result.setDate(result.getDate() - numberOfDays);
  return result;
}

export function findAppendDeleteInsideArray(arrayTotal, entity, methodType, arrayName) {
  let payloadChildren;
  let categoryOrLocation = (arrayName === 'category') ? 'categoria' : 'localização';
  let parent = {
    location: 'parentLocation',
    category: 'parentCategory',
  };
  if (entity.payload) {
    payloadChildren = {
      name: entity.payload.name,
      id: entity.response.data.id,
      children: [],
    };
  }

  let type = parent[arrayName];
  for (let i = 0; i < arrayTotal.length; i++) {
    if (arrayTotal[i].children) {
      if (methodType === 'append') {
        if (entity.payload[type] === arrayTotal[i].id) {
          if (arrayTotal[i].children[0]) {
            if (arrayTotal[i].children[0].warning) {
              arrayTotal[i].children.pop();
            }
          }
          payloadChildren[type] = arrayTotal[i].id;
          arrayTotal[i].children.push(payloadChildren);
        } else {
          findAppendDeleteInsideArray(arrayTotal[i].children, entity, 'append', arrayName);
        }
      } else {
        if (arrayTotal[i].id === entity) {
          arrayTotal.splice(i, 1);
          if (arrayTotal.length === 0) {
            arrayTotal.push({
              name: `Essa ${categoryOrLocation} não possui outros níveis`,
              warning: true,
            });
          }
        } else {
          findAppendDeleteInsideArray(arrayTotal[i].children, entity, 'delete', arrayName);
        }
      }
    }
  }
}

export function getZipcodeData(zipcode) {
  if (zipcode.length < 9) {
    return false;
  }
  let zipcodeFormatted = zipcode.replace(/\D/g, '');

  let validZipcode = /^[0-9]{8}$/;

  if (zipcodeFormatted) {
    if (validZipcode.test(zipcodeFormatted)) {
      return new Promise((resolve, reject) => {
        axios.get('https://cep.redeforce.app/v1/addresses/' + zipcodeFormatted)
             .then(response => {
               resolve(response.data);
             })
             .catch(error => {
               reject(error.response);
             });
      });
    }
  }
}

export function openInputFile() {
  document.querySelector('#file-input').click();
}

export function appendInputFile(registerName) {
  let fileInput = document.querySelector('#file-input');
  let reader = new FileReader();
  reader.readAsDataURL(fileInput.files[0]);
  reader.onload = function () {
    let base64 = (reader.result).split(',')[1];
    registerName.files.push({
      name: (fileInput.files[0].name).split('.')[0],
      fileData: base64,
      fileExt: '.' + (fileInput.files[0].name).split('.')[1],
    });
  };
  reader.onerror = function (error) {
    console.log(error);
  };
}

export function listCities(item) {
  if (item && item.id) {
    return listCitiesbyState(item.id) ? listCitiesbyState(item.id).data : [];
  } else if (item && item.address && item.address.state && item.address.state.id) {
    return listCitiesbyState(item.address.state.id)
           ? listCitiesbyState(item.address.state.id).data
           : [];
  } else if (item && item.address && item.address.state) {
    return listCitiesbyState(item.address.state)
           ? listCitiesbyState(item.address.state).data
           : [];
  } else {
    return listCitiesbyState(item) ? listCitiesbyState(item).data : [];
  }
}

export function openFileBlankTab(item, path) {
  let parentName;
  if (path === 'parties') {
    parentName = 'party';
  } else if (path === 'system/biddings') {
    parentName = 'bidding';
  } else if (path === 'users') {
    parentName = 'user';
  } else {
    parentName = 'constructions';
  }

  baseStore.actions.getFileData('', { path, parentId: item[parentName], file: item.id })
           .then(response => {
             downloadFileData(response.data);
           })
           .catch(catchErrorDefault);
}

export function downloadFileData(file) {
  let element = document.createElement('a');
  let fileName = (file.fileExt) ? file.name + '.' + file.fileExt : file.name;
  element.setAttribute('href', 'data:application/octet-stream;charset=utf-16le;base64,' + file.fileData);
  element.setAttribute('download', fileName);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export function taxIdFormatted(taxId) {
  if (taxId && taxId.length === 11) {
    return taxId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (taxId && taxId.length > 11) {
    return taxId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
}

export function handleSuccess(successResponse, alternativeMessage) {
  let messagePath = (successResponse.data) ? successResponse.data.message : successResponse.message;
  if (!isNullOrEmpty(messagePath)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, messagePath);
  } else if (!isNullOrEmpty(alternativeMessage)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, alternativeMessage);
  }
}

export function catchErrorDefault(error) {
  console.log(error);
  if (!!error.message && (error.message.indexOf('totalApiData') !== -1)) {
    return false;
  }

  if (isNullOrEmpty(error.data)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, 'Ocorreu um erro desconhecido. Tente novamente, e caso o problema persista, entre em contato com o suporte.');
    return false;
  }

  if ([ 500, 401, 405 ].includes(error.status)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, 'Não foi possível processar sua requisiçao. Tente novamente, e caso o problema persista, entre em contato com o suporte.');
  } else if (!isNullOrEmpty(error.data.error)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, error.data.error);
  } else if (!isNullOrEmpty(error.data.description)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, error.data.description);
  } else if (!isNullOrEmpty(error.data.message)) {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, error.data.message);
  } else {
    baseStore.mutations.SET_SNACKBAR(baseStore.state, 'Ocorreu um erro desconhecido. Tente novamente, e caso o problema persista, entre em contato com o suporte.');
  }

  baseStore.mutations.SET_APP_LOADING(baseStore.state, false);
}

export function catchFormError(error, form) {
  if (!isNullOrEmpty([ 'error', 'message', 'description' ].filter(item => Object.keys(error.data).includes(item)))) {
    catchErrorDefault(error);
    return;
  }

  for (let errorLabel of Object.keys(error.data)) {
    form.setErrors({
      [errorLabel]: [ error.data[errorLabel] ],
    });
  }
}

export function formattedPrice(price) {
  return Number(price).toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
}

export function replaceAll(value, search, replace) {
  return value.split(search).join(replace);
}

export function addDeletedAttribute(entity, parentArray) {
  entity.deleted = true;
  parentArray.push(1);
  parentArray.pop();
}

export function navigationGuard(pathMeta, appUser, systemType = 'basic') {
  let routeIncludesUserPermission = pathMeta.userType.includes(parseInt(appUser.type));
  if (systemType === 'basic') {
    return routeIncludesUserPermission;
  }

  if (routeIncludesUserPermission && appUser.type !== userType.TYPE_USER) {
    return true;
  } else if (routeIncludesUserPermission) {
    return !!(pathMeta.permissions.tenantUserType.includes(parseInt(appUser.tenants[0].type)));
  }
}

export function prepareApiParams(params, fields = null) {
  let correctParams;

  if (!isNullOrEmpty(params)) {
    correctParams = {
      limit: params.limit ?? 100,
      page: params.page,
      orderBy: params.orderBy,
      search: params.search,
      active: params.active,
    };

    for (let index in correctParams) {
      if (isNullOrEmpty(correctParams[index])) {
        delete correctParams[index];
      }
    }

    if (!isNullOrEmpty(params.orderBy) && params.orderBy.split(' ')[0] === 'undefined') {
      delete correctParams.orderBy;
    }
  } else {
    correctParams = {
      offset: 100,
    };
  }

  if (!isNullOrEmpty(fields)) {
    correctParams.fields = fields;
  }

  return correctParams;
}

export function prepareApiFilters(query, filterFields) {
  if (!isNullOrEmpty(filterFields)) {
    for (let filter in filterFields) {
      if (!isNullOrEmpty(filterFields[filter])) {
        query[filter] = filterFields[filter];
      }
    }
  }

  return query;
}

export function cloneDeep(variableBase) {
  return JSON.parse(JSON.stringify(variableBase));
}

export function compareRoleArray(dataModel, rolesChosen, rolesChosenBase, method) {
  let rolesChosenCopy = rolesChosen;
  if (method === 'update') {
    for (let newRole of rolesChosenCopy) {
      for (let oldRole of rolesChosenBase) {
        if (newRole === oldRole) {
          rolesChosenCopy = rolesChosenCopy.filter(item => item !== newRole);
          rolesChosenBase = rolesChosenBase.filter(item => item !== newRole);
        }
      }
    }
    if (!!rolesChosenBase) {
      for (let j = 0; j < rolesChosenBase.length; j++) {
        for (let i = 0; i < dataModel.length; i++) {
          if (dataModel[i].type === rolesChosenBase[j]) {
            dataModel[i].deleted = true;
          }
        }
      }
    }
    if (!!rolesChosenCopy.length) {
      for (let role of rolesChosenCopy) {
        if (!dataModel.find(item => item.type === role)) {
          dataModel.push({
            type: role,
          });
        }
      }
    }
  } else {
    for (let role of rolesChosenCopy) {
      dataModel.push({
        type: role,
      });
    }
  }

  return dataModel;
}

export function isNullOrEmpty(value) {
  return (value == null) ||
    (value === '') ||
    ((typeof value === 'object') && (Object.keys(value).length === 0)) ||
    (Array.isArray(value) && (value.length === 0));
}

export function verifyDebug() {
  if (location.href.includes('XDEBUG_SESSION_START')) {
    let hrefSplitted = location.href.split('XDEBUG_SESSION_START=');
    sessionStorage.setItem('apiDebug', hrefSplitted[1]);
    location.href = hrefSplitted[0];
  }
}

export function hideFabButtons() {
  if (!!document.querySelectorAll('.v-btn--fab').length) {
    document.querySelector('.v-btn--fab').classList.add('d-none');
  }
}

export function defineSubmitMethod(entity) {
  return (isNullOrEmpty(entity.id) || entity.id === 0) ? 'create' : 'update';
}

export function renovateAPIToken() {
  return new Promise((resolve, reject) => {
    api.put('auth')
       .then((response) => {
         baseStore.mutations.SIGN_IN(baseStore.state, prepareUserDataAndTokenToSave(response));
         resolve(true);
       })
       .catch(reject);
  });
}

export function prepareUserDataAndTokenToSave(response) {
  const apiToken = response.data.token;
  const appUser = JSON.stringify(response.data.user);
  let data = {
    'apiToken': apiToken,
    'appUser': appUser,
  };
  if (response.data.user.type === userType.TYPE_USER) {
    window.localStorage.setItem('apiToken', apiToken);
    window.localStorage.setItem('appUser', appUser);
  } else {
    window.sessionStorage.setItem('apiToken', apiToken);
    window.sessionStorage.setItem('appUser', appUser);
  }

  return data;
}

export function handle401Error() {
  renovateAPIToken()
    .then(() => {
      baseStore.mutations.SET_SNACKBAR(baseStore.state, 'Token de autenticação renovado!');
    })
    .catch((error) => {
      baseStore.mutations.SIGN_OUT(baseStore.state);
      catchErrorDefault(error);
      router.push('/login');
      alert('Sessão expirada! Faça o login novamente');
    });
}

export function removeFullAddressField(entityAddress) {
  entityAddress.forEach(item => delete item.address.fullAddress);
  return entityAddress;
}

export function parseSingleAddressToAPI(payload) {
  payload.addresses.forEach(item => delete item.address.fullAddress);
  let address = payload.addresses[0].address;
  delete address.key;
  delete payload.addresses;

  return address;
}

export function parseAddressToApp(payload) {
  let copyAddress = [];

  if (!isNullOrEmpty(payload.addresses) && !payload.addresses[0].id) {
    payload.addresses.forEach(item => item.id = item.address.id);
    copyAddress = payload.addresses;
  } else if (!isNullOrEmpty(payload.addresses)) {
    copyAddress = payload.addresses;
  } else if (!isNullOrEmpty(payload.address)) {
    copyAddress.push({ id: payload.address.id, address: payload.address });
    delete payload.address;
  } else {
    copyAddress = [
      {
        address: {
          zipCode: null,
          city: null,
          state: null,
          address: null,
          number: null,
        },
      },
    ];
  }
  return copyAddress;
}

export function getFileNameAndFileExt(file) {
  let lastIndex = file.name.lastIndexOf('.');
  return {
    name: file.name.slice(0, lastIndex),
    fileExt: file.name.slice(lastIndex + 1),
  };
}

export function getAllInformationsFromFile(currentFile) {
  //TODO melhorar essa função - ? async ?
  let fileInformation = {};
  let reader = new FileReader();
  reader.readAsDataURL(currentFile);
  reader.onload = () => {
    fileInformation = getFileNameAndFileExt(currentFile);
    fileInformation.fileData = (reader.result).split(',')[1];
    return fileInformation;
  };

  reader.onerror = function (error) {
    console.log(error);
  };
}
